import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onFeatureAll, onUnfeatureAll, onDeleteAll, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-card border border-border rounded-lg shadow-xl px-6 py-4 z-[900] flex items-center gap-4">
      <div className="flex items-center gap-2 text-sm font-medium text-text-primary">
        <Icon name="CheckSquare" size={18} />
        <span>{selectedCount} selected</span>
      </div>

      <div className="h-6 w-px bg-border" />

      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={onFeatureAll}
          iconName="Star"
          iconPosition="left"
          iconSize={14}
        >
          Feature All
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onUnfeatureAll}
          iconName="StarOff"
          iconPosition="left"
          iconSize={14}
        >
          Unfeature All
        </Button>
        <Button
          variant="destructive"
          size="sm"
          onClick={onDeleteAll}
          iconName="Trash2"
          iconPosition="left"
          iconSize={14}
        >
          Delete All
        </Button>
      </div>

      <div className="h-6 w-px bg-border" />

      <Button
        variant="ghost"
        size="sm"
        onClick={onClearSelection}
        iconName="X"
        iconSize={14}
      >
        Clear
      </Button>
    </div>
  );
};

export default BulkActionsBar;